const authBackgroundUrl = "/public_mountain.jpg";
const logoLightUrl = "/public_logo-white.png";
const logoDarkUrl = "/freetech-logo-black.png";
const logoNoBackgroundUrl = "/public_logo-no-background.png";


export const imageUrls = {
  authBackground: authBackgroundUrl,
  logoLight: logoLightUrl,
  logoDark: logoDarkUrl,
  logoNoBackground: logoNoBackgroundUrl,
};


const preloadImage = (src: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(src);
    img.onerror = () => {
      console.error(`Failed to preload image: ${src}`);
      reject(new Error(`Failed to preload image: ${src}`));
    };
    img.src = src;
  });
};


export const preloadAllImages = async (): Promise<void> => {
  try {
    await Promise.all([
      preloadImage(authBackgroundUrl),
      preloadImage(logoLightUrl),
      preloadImage(logoDarkUrl),
      preloadImage(logoNoBackgroundUrl),
    ]);
  } catch (error) {
    console.error("Error preloading images:", error);
  }
};


export const authBackground = authBackgroundUrl;
export const logoLight = logoLightUrl;
export const logoDark = logoDarkUrl;
export const logoNoBackground = logoNoBackgroundUrl;
